<rask-checkbox
  text="Pågående"
  [(ngModel)]="visaActive"
  (ngModelChange)="filterChanged()"
  [ngModelOptions]="{standalone: true}">
</rask-checkbox>
<rask-checkbox
  text="Fel"
  [(ngModel)]="visaError"
  (ngModelChange)="filterChanged()"
  [ngModelOptions]="{standalone: true}">
</rask-checkbox>
<rask-checkbox
  text="Ok"
  [(ngModel)]="visaOk"
  (ngModelChange)="filterChanged()"
  [ngModelOptions]="{standalone: true}">
</rask-checkbox>
@if (filteredAktiviteter) {
  <rask-list [data]="filteredAktiviteter" [useClientFilter]="true"
    clientFilterResultText="Aktiviteter">
    <rask-list-column header="Beteckning" field="titleLong" [sortable]="true">
      <ng-template let-row="row">
        <a [routerLink]="['/planera', $safeNavigationMigration(row.metadata?.entityId)]">
          {{ row.titleLong }}
        </a>
        <a [routerLink]="['/planera', $safeNavigationMigration(row.metadata?.entityId)]"
          target="_blank">
          <i class="far fa-sm fa-external-link p-r-half"></i>
        </a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Status" field="status" [sortable]="true"></rask-list-column>
    <rask-list-column header="Status" width="80px">
      <ng-template let-row="row">
        <rask-icon [text]="row.message" [icon]="getStatusIcon(row.status)"></rask-icon>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Meddelande" field="message"></rask-list-column>
    <rask-list-column header="Senast uppdaterad" field="lastUpdated"></rask-list-column>
    <rask-list-column>
      <ng-template let-row="row">
        @if (showDismiss(row)) {
          <rask-icon-button class="remove-button" icon="far fa-trash-alt"  (click)="dismissActivity(row.id)"  negative></rask-icon-button>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
}
